export default __webpack_public_path__ + "static/media/Group8892.ab4c7efe.svg";